import { useTranslation } from 'react-i18next';

import { VModal, useFlag, useUnleash } from '@/package';
import type { FrameData, Task } from '@/type';

import { ReviewerHandoffModalContent } from './ReviewerHandoffModalContent';

type ReviewerHandoffControllerProps = {
  frameSeq?: FrameData['frameSeq'][];
  handoffType: 'each' | 'all';
  taskID: Task['id'];
};

export const ReviewerHandoffModalController = ({
  children,

  frameSeq,
  handoffType = 'each',
  taskID,
}: React.PropsWithChildren<ReviewerHandoffControllerProps>) => {
  const { isEnabled } = useUnleash();
  const { t } = useTranslation();
  const { value: visible, setFalse: hide, setTrue: show } = useFlag(false);
  const isHandoffEnabled = isEnabled('vuex.sapporo.reviewerHandoff');

  return isHandoffEnabled ? (
    <>
      <div
        role="presentation"
        onClickCapture={e => {
          e.stopPropagation();
          e.preventDefault();
          show();
        }}
      >
        {children}
      </div>
      <VModal
        noCloseOnEsc
        size="small"
        visible={visible}
        onUpdateVisible={visible => (visible ? show() : hide())}
      >
        <ReviewerHandoffModalContent
          frameSeq={frameSeq}
          message={
            handoffType === 'each'
              ? t('task.reviewerHandoffModalIndividualMessage.blowfly')
              : t('task.reviewerHandoffModalEntireMessage.shortfall')
          }
          taskID={taskID}
          onClose={hide}
        />
      </VModal>
    </>
  ) : (
    <></>
  );
};

ReviewerHandoffModalController.displayName = 'ReviewerHandoffModalController';
